<template>
  <div>
     <div class="petition-counter">
        <h2>
          <count-to ref="counter" :startVal='startCounter' :end-val='endCounter' :autoplay=false :duration='7000' @callbackCounter='updatePercentage'></count-to>
        </h2>
        <h5>{{ counterTitle }}</h5>
        <hr>
        <p class="form-intro">
          {{ title }}
        </p>
    </div>

    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
        <div class="petition-form">
  
          <p class="form-intro">
            <div v-html="intro"></div>
          </p>
  
          <div>
            <input name="firstName" type="text" v-model="firstName" v-validate="{ required: true}" :class="{'border-red': errors.has('firstName')}" placeholder="First name" autocomplete="given-name"
              v-on:focus="logFirstTouch('first name')">
            <input name="lastName" type="text" v-model="lastName" v-validate="{ required: true}" :class="{'border-red': errors.has('lastName')}" placeholder="Last name" autocomplete="family-name"
              v-on:focus="logFirstTouch('last name')">

            <!-- EMAIL -->
            <div class="with-input-loading">
              <input
                name="email"
                type="email"
                v-model="email"
                v-validate="{ required: true, petitionEmailIsValid: true, email: true }"
                :class="{'border-red': errors.has('email')}"
                placeholder="Email"
                @input="onEmailInput()"
                v-on:focus="logFirstTouch('email')"
              >
              <div class="input-loading" v-if="emailCheckSensis.checkEmailLoading">
                <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/loading-tail-spin.svg" />
              </div>
              <span class="wwf-alert">
                <p v-if="errors.has('email')">{{ errors.first('email') }}</p>
              </span>
            </div>

            <!-- COUNTRY -->
            <select
              name="country"
              v-model="country"
              v-validate="'required'"
              :class="{ 'border-red': errors.has('country') }"
              autocomplete="country"
              v-on:focus="logFirstTouch('country')"
              v-if="showCountry"
            >
              <option
                v-for="(countries, index) in countriesList"
                :value="countries.name"
              >
                {{ countries.name }}
              </option>
            </select>

            <!-- POST CODE -->
            <input 
              name="postcode" 
              :type="this.country === 'Australia' ? 'number' : 'text'"
              v-model="postcode" 
              placeholder="Postcode / Zip code"
              @input="postcodeUpdated()"
              v-validate="{ required: true, petitionPostCodeIsValid: true }" 
              :class="{'border-red': errors.has('postcode')}"
              v-on:focus="logFirstTouch('postcode')"
            >

            <span class="wwf-alert">
              <p v-if="errors.firstByRule('postcode','petitionPostCodeIsValid') || errors.firstByRule('postcode')">{{errors.first('postcode')}}</p>
            </span>

            <!-- PHONE NUMBER -->
            <input 
              name="phoneNumber"
              type="tel"
              v-model="phoneNumber"
              placeholder="Phone Number"
              v-validate="{ required: true, petitionPhoneNumberIsValid: true }"
              :class="{'border-red': errors.has('phoneNumber')}"
              v-on:focus="logFirstTouch('phone')"
            >

            <span class="wwf-alert">
              <p v-if="errors.firstByRule('phoneNumber', 'petitionPhoneNumberIsValid')">{{ errors.first('phoneNumber') }}</p>
            </span>
            <!-- Display Name -->
            <label>
              <input
                type="checkbox"
                class="checkbox"
                name="displayName"
                checked
                v-model="saveSignature"
                v-on:focus="logFirstTouch('display my name')"
              />
              Yes, display my name
            </label>

            <!-- Recipients list -->
            <div class="recipients-list" v-if="state !== '' && recipients != null">
              <div class="recipients-title">You will be contacting</div>

              <!-- MP -->
              <!-- Multiple MPs -->
              <div class="mps-list" v-if="recipients.mps.length > 1">
                <div>Select your MP</div>
                <div class="wwf-radio-bttns mp-item">
                  <label :for="'mp-' + mp.email" v-for="mp in recipients.mps">
                    <input
                      type="radio"
                      v-validate="'required'"
                      v-model="selectedMP"
                      name="selectedMP"
                      :value="mp"
                      :id="'mp-' + mp.email"
                    />
                    {{ mp.salutation }} {{ mp.name }}, MP
                    <span class="wwf-radio"></span>
                  </label>
                </div>
              </div>

              <!-- Single MP -->
              <div class="recipient" v-else-if="selectedMP != null">• {{ selectedMP.salutation }} {{ selectedMP.name }}, MP</div>
            </div>
            
            <!-- Submit Btn -->
            <input 
              type="button" 
              class="btn-submit" 
              v-on:click="save()" 
              :disabled="isSaving" 
              :value="isSaving ? 'Loading...' : 'Add my name'" 
            />
            <div class="privacy-statement">
              <p>By signing you accept
                <a href="https://wwf.org.au/about-us/privacy-policy/" target="_blank">WWF-Australia&rsquo;s Privacy Policy.</a>
              </p>
            </div>
          </div>

          <!-- Last signatures - Always present whatever step we are-->
          <div class="ls-title">{{ signatureTitle }}</div>
          <lastSignatures
            :campaignId="datalayerName"
            :numberOfSignatures="numberOfSignatures"
            :signature="signature"
            iconSource="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/nfr-turtle-icon.svg"
            classes="net-north-north-last-signatures"
          ></lastSignatures>
            
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import countTo from "vue-count-to";
import { mapState } from "vuex";
import firebase from "firebase";
import lastSignatures from "./../utils/LastSignatures";

const { detect } = require("detect-browser");
const browser = detect();
import { 
  getParameterByName,
  getCountriesList,
  getAustralianStateByPostcode
 } from "../../helpers";

export default {
  components: { countTo, lastSignatures },
  name: "net-free-north-form",
  created: function () {
    // Fetch directly from firebase
    firebase
      .firestore()
      .collection("campaigns")
      .doc(this.datalayerName)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (!!data) {
            this.endCounter = data.count;
            if (this.$refs.counter) {
              this.$refs.counter.start();
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );

    // Get utm_source from iframe src
    this.utmSourceParam = getParameterByName("utm_source");

    // Check if there are some query string in URL to prefill the form, Query from donate widget
    let q = getParameterByName("q", window.top.location.href);
    if (q) {
      let decodeQuery = "?" + window.atob(q);
      this.firstName = getParameterByName("firstname", decodeQuery);
      this.lastName = getParameterByName("lastname", decodeQuery);
      this.email = getParameterByName("email", decodeQuery);
      this.postcode = getParameterByName("postcode", decodeQuery);
      this.phoneNumber = getParameterByName("phone", decodeQuery);
    }

    // Define if we show the counter
    this.$store.dispatch("getCounterByCampaignId", this.datalayerName);

    // Check the email
    let petitionEmailIsValid = (email) => {
      return new Promise((resolve, reject) => {
        Promise.all([this.checkEmailDuplicate(), this.checkEmail()])
          .then((results) => {
            for (const r of results) {
              if (!r.valid) {
                return resolve(r);
              }
            }
            this.errors.remove("email");
            resolve({ valid: true });
          })
          .catch((err) => {
            console.error(err);
            this.errors.remove("email");
            resolve({ valid: true });
          });
      });
    };

    Validator.extend("petitionEmailIsValid", {
      validate: petitionEmailIsValid,
      getMessage: (field, params, data) => data.message,
    });

    // Check the postcode
    let petitionPostCodeIsValid = (postcode) => {
      // Validate the postcode for Australia only
      if (
        this.country === "Australia" &&
        (isNaN(+postcode) || +postcode < 0 || +postcode > 9999)
      ) {
        return {
          valid: false,
          data: { message: "Please enter a postcode between 0000 and 9999" },
        };
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("petitionPostCodeIsValid", {
      validate: petitionPostCodeIsValid,
      getMessage: (field, params, data) => data.message,
    });

    // Check Phone Number
    let petitionPhoneNumberIsValid = (phoneNumber) => {
      const validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
        return {
          valid: false,
          data: { message: "Invalid phone number" },
        };
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("petitionPhoneNumberIsValid", {
      validate: petitionPhoneNumberIsValid,
      getMessage: (field, params, data) => data.message,
    });
  },
  mounted: function () {
    if (this.$refs.counter) {
      this.$refs.counter.start();
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  props: {
    // Header
    title: {
      // title="Test title"
      type: String,
      required: true,
    },
    intro: {
      // intro="Test intro"
      type: String,
      required: false,
    },
    counterTitle: {
      // counter-title="Test message sent"
      type: String,
      default: "message sent",
    },
    limit: {
      type: Number,
      default: 1000,
    },

    // Meta
    datalayerName: {
      // datalayerName="Test datalayer name"
      type: String,
      required: true,
    },
    isActive: {
      // :is-active="false"
      type: Boolean,
      required: true,
    },

    // Lead (Marketo, IVE, ...)
    programName: {
      // program-name="Test petition name"
      type: String,
      required: true,
    },

    // Toggles
    showCountry: {
      // :show-country="true"
      type: Boolean,
      default: false,
    },

    // Thank you
    thankYouUrl: {
      // Attribute for the productID
      type: String,
      default: "https://wwf.org.au/donate/thank-you-for-helping/",
    },

    // Signature
    signatureTitle: {
      type: String,
      default: "Net-Free Reef Supporters",
    },
    signature: {
      type: String,
      default: "supports a Net-Free Reef",
    },
    numberOfSignatures: {
      type: Number,
      default: 3,
    },
  },
  data: function () {
    return {
      utmSourceParam: "",

      percentage: 0,
      startCounter: 0,
      endCounter: 0,

      firstName: "",
      lastName: "",
      email: "",
      postcode: "",
      phoneNumber: "",
      country: "Australia",

      countriesList: getCountriesList(),

      saveSignature: false,
      isLoading: false,
      error: false,
      isShake: false,
      isSaving: false,
      formTouched: false,
      state:'',
      recipients: null,
      selectedMP: null,

      timeout: null,
      lastApiTimestamp: Date.now(),
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/,
      },
    };
  },
  methods: {
    onEmailInput: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(() => {
        this.checkEmailDuplicate()
          .then((result) => {
            if (!result.valid) {
              this.errors.add({
                field: "email",
                msg: "Your email has already been submitted",
              });
            }
          })
          .catch((err) => {
            // If it fails, let the user free to continue
            console.log(err);
          });
      }, 500);
    },
    checkEmailDuplicate: function () {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("checkEmail", {
            campaignId: this.datalayerName,
            email: this.email,
          })
          .then((result) => {
            if (result) {
              resolve({
                valid: false,
                field: "email",
                data: { message: "Your email has already been submitted" },
              });
            } else {
              resolve({ valid: true });
            }
          });
      });
    },
    checkEmail: function () {
      return new Promise((resolve, reject) => {
        let timestamp = Date.now(); // timestamp for this api call
        this.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        this.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        this.$store
          .dispatch("validateEmail", this.email)
          .then((response) => {
            if (response && timestamp >= this.emailCheckSensis.lastTimestamp) {
              this.emailCheckSensis.checkEmailLoading = false;
              resolve(response);
            }
          })
          .catch((err) => {
            console.error(err);
            this.emailCheckSensis.checkEmailLoading = false;
            // If it fails, let the user free to continue
            resolve({ valid: true });
          });
      });
    },
    updatePercentage: function (e, t) {
      this.percentage = (e * 100) / this.limit;
    },
    save: function () {
      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      let postBody = {
        programName: this.programName,
        cookieID: this.$cookie.get("_mkto_trk"),
        ssoId: this.$store.getters.ssoId,

        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: this.postcode,
        phone: this.phoneNumber,
        country: this.country,
        selectedMP: this.selectedMP,
        state: this.state,

        utmSource: this.utmSourceParam,
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then((result) => {
        if (result) {
          this.saveLead(postBody);

          // Log step to Amplitude
          this.$store.dispatch("logPetitionSupporter", {
            id: postBody.programName,
            postcode: postBody.postcode,
          });
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayerName,
              event: "formSubmitEvent",
            });
          }
          this.isSaving = false;
          this.isShake = true;
          setTimeout(
            function () {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
    saveLead: function (postBody) {
      this.$store
        .dispatch("saveLead", {
          campaignId: this.datalayerName,
          lead: postBody,
          saveSignature: this.saveSignature,
        })
        .then(
          (response) => {
            console.log("petition submit success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: this.datalayerName,
                event: "formSubmitSuccessEvent",
              });
            }

            // Log registration to Amplitude
            this.$store.dispatch("logPetitionComplete", {
              id: this.programName,
              count: this.endCounter,
            });

            // Reset form
            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.postcode = "";
            this.country = "Australia";
            this.checked = false;            
            this.state = "";
            this.phoneNumber = "";
            this.isSaving = false;
            this.recipients = null;

            // Redirect to thank you
            window.top.location.href = this.thankYouUrl;
          },
          (error) => {
            console.error("Petition submit failed");
            this.isSaving = false;
          }
        )
        .catch((err) => {
          console.error("Petition submit failed");
          this.isSaving = false;
        });
    },
    logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programName,
          fieldName,
          count: this.endCounter,
        });
        this.formTouched = true;
      }
    },
    updateState: function() {
      if (this.postcode && this.postcode.toString().length >= 3) {
        const state = getAustralianStateByPostcode(this.postcode);
        if (state && this.state != "Outside Australia") {
          this.state = state;
          this.errors.remove('postcode');
        } else {
          this.state = '';
        }
      } else {
        this.state = '';
      }
    },
    postcodeUpdated: function() {
      this.updateState();
      if (this.postcode && this.postcode.toString().length >= 3) {
        this.updateRecipients();
      }
    },
    updateRecipients: function() {
      this.$store.dispatch("getNetFreeNorthMPs", { postcode: this.postcode })
        .then(result => {
          if (result) {
            this.recipients = result;
            if (this.recipients.mps.length != 0) {
              this.selectedMP = this.recipients.mps[0];
            } else {
              this.selectedMP = this.recipients.envMinister;
            }
          }
        })
    },
  },
};
</script>

<style lang="css" scoped>
.petition-header,
.petition-counter {
  /* margin: -20px -20px 20px; */
  padding: 20px 20px 0px;
  border-bottom: 1px solid var(--wwfGreyDE);
  background-color: var(--wwfBrandBlack);
}

.petition-header {
  display: flex;
  flex-direction: column;
  margin-bottom: -20px;
  padding: 40px;
}

.petition-header,
.petition-counter h2,
h5,
p {
  color: var(--wwfWhite);
}

.petition-counter h5 {
  margin-top: 20px;
}

.petition-header h4 {
  margin-top: 14px;
  font-size: 32px;
  font-family: "WWF";
  font-weight: 400;
  line-height: 32px;
}

.petition-counter hr {
  border: 1px solid var(--wwfWhite);
  opacity: 0.4;
}

.petition-header-img {
  width: 75px;
  height: 75px;
}

.petition-header-img img {
  width: 100%;
}

.petition-header ul {
  margin-top: 12px;
  font-size: 18px;
}

.petition-header ul li {
  margin-top: 16px;
  font-size: 18px;
}

.petition-header ul li:nth-child(1) {
  margin-top: 0px;
}

.petition-header hr {
  width: 100%;
  opacity: 0.2;
}

span.wwf-alert {
  position: absolute;
  display: block;
  text-align: left;
  width: 100%;
  pointer-events: none;
  z-index: 9;
}

span.wwf-alert p {
  position: relative;
  background-color: var(--errorColor);
  left: 0;
  top: -18px;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  padding: 5px 10px;
  line-height: normal;
  border-radius: 3px;
  color: var(--wwfWhite);
  font-size: 13px;
  box-shadow: 0 3px 13px var(--wwfTransparentBlack020);
  z-index: 10;
  font-weight: 600;
}

.recipients-list {
  padding: 0.5rem;
  margin: 0 0 1rem;
  background-color: var(--wwfTransparentBlack005);
  color: var(--wwfGrey47);
}

.recipients-title {
  margin: 0 0 5px;
}

.recipient {
  margin: 0 0 0 10px;
}

.mps-list {
  margin: 5px 0 0 10px;
}

.mp-item {
  margin: 0 0 0 15px;
}

.mp-item input {
  margin-bottom: 5px;
}

.btn-submit:disabled {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.input-loading {
  top: 6px;
}

.petition-form.wwf-form input[type="button"] {
  background-color: #00728f;
}

.petition-form.wwf-form input[type="button"]:hover {
  background-color: #178eb2;
  color: var(--wwfWhite);
}

.petition-form.wwf-form input.read-letter {
  background-color: var(--wwfWhite);
  font-family: "Lato", sans-serif;
  color: var(--wwfBlue);
  mix-blend-mode: normal;
  border: 1px solid var(--wwfBlue);
  box-sizing: border-box;
  border-radius: 3px;
}

.petition-counter {
  background-color: #00728f;
}

.checkbox {
  border: 2px solid #00728f;
}

/* Signatures */
.ls-title {
  color: #00728f;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// NetFreeNorthForm.vue?e795d48c